// Updates the preview pills inside the "Customize search appearance" drawer
// as the user types into the Red/Yellow/Green label inputs. Falls back to
// the default text ("May bill you directly" / "Could bill you directly" /
// "Unlikely to balance bill") when the
// input is empty — kept in sync with SEARCH_APPEARANCE_DEFAULT_LABELS in
// Partners::ProviderIntelligenceHelper.
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "redInput", "yellowInput", "greenInput",
    "redPreview", "yellowPreview", "greenPreview",
    "cardPillRed", "cardPillYellow", "cardPillGreen",
    "cardRedLabel", "cardYellowLabel", "cardGreenLabel",
    "previewTab",
  ];

  submitForm() {
    this.element.requestSubmit();
  }

  update() {
    if (this.hasRedInputTarget && this.hasRedPreviewTarget) {
      const value = this.redInputTarget.value.trim();
      const text = value === "" ? "May bill you directly" : value;
      this.redPreviewTarget.textContent = text;
      if (this.hasCardRedLabelTarget) this.cardRedLabelTarget.textContent = text;
    }
    if (this.hasYellowInputTarget && this.hasYellowPreviewTarget) {
      const value = this.yellowInputTarget.value.trim();
      const text = value === "" ? "Could bill you directly" : value;
      this.yellowPreviewTarget.textContent = text;
      if (this.hasCardYellowLabelTarget) this.cardYellowLabelTarget.textContent = text;
    }
    if (this.hasGreenInputTarget && this.hasGreenPreviewTarget) {
      const value = this.greenInputTarget.value.trim();
      const text = value === "" ? "Unlikely to balance bill" : value;
      this.greenPreviewTarget.textContent = text;
      if (this.hasCardGreenLabelTarget) this.cardGreenLabelTarget.textContent = text;
    }
  }

  switchPreviewTab(event) {
    const selected = event.currentTarget.dataset.tab;
    const colors = ["red", "yellow", "green"];
    const pillTargets = {
      red: this.hasCardPillRedTarget ? this.cardPillRedTarget : null,
      yellow: this.hasCardPillYellowTarget ? this.cardPillYellowTarget : null,
      green: this.hasCardPillGreenTarget ? this.cardPillGreenTarget : null,
    };

    colors.forEach((color) => {
      if (pillTargets[color]) {
        pillTargets[color].classList.toggle("hidden", color !== selected);
      }
    });

    this.previewTabTargets.forEach((tab) => {
      if (tab.dataset.tab === selected) {
        tab.classList.remove("inactive-nav");
        tab.classList.add("active-nav");
      } else {
        tab.classList.remove("active-nav");
        tab.classList.add("inactive-nav");
      }
    });
  }
}
